<div class="inner-page-wrapper">
    <app-sub-nav-legal />
    <div class="py-40 md:py-[80px]">
        <h1 class="mb-24 font-headline text-20 font-medium leading-25 text-black md:mb-40 md:text-34 md:leading-41">
            Rechtliche Hinweise
        </h1>
        <p class="text-16 leading-27 text-black">
            <strong>Urheberrechte / Copyright</strong>
            <br />
            Alle Rechte vorbehalten. Texte, Bilder, Ton- und Videodateien sowie Grafiken und andere auf dieser Website
            veröffentlichten Informationen und geschützte Werke unterliegen &dash; sofern nicht anders gekennzeichnet
            &dash; dem Copyright/Urheberrecht der {{ dealerName() }} vertreten durch {{ dealer().managingDirector }}.
            Jede Verwertung im Sinne des Urheberrechts (Vervielfältigung, Verbreitung, Speicherung, Sendung und Wieder-
            bzw. Weitergabe) der Inhalte für gewerbliche Zwecke ist ohne schriftliche Genehmigung der
            {{ dealerName() }} vertreten durch {{ dealer().managingDirector }} untersagt.
            <br />
            Wir weisen darauf hin, dass auf den Webseiten enthaltene Bilder teilweise dem Urheberrecht Dritter
            unterliegen.
            <br />
            <br />
            <strong>Markenzeichen</strong>
            <br />
            Soweit nicht anders angegeben, sind alle Markenzeichen auf dieser Webseite markenrechtlich zugunsten der
            {{ dealerName() }} vertreten durch {{ dealer().managingDirector }} geschützt. Dies gilt insbesondere für
            Marken, Typenbezeichnungen, Logos und Embleme.
            <br />
            <br />
            <strong>Haftungsausschluss</strong>
            <br />
            {{ dealerName() }} vertreten durch {{ dealer().managingDirector }} stellt die Inhalte der Website mit
            größter Sorgfalt bereit und aktualisiert die Angaben regelmäßig. Trotzdem kann keine Gewähr für die
            Fehlerfreiheit und Genauigkeit der enthaltenen Informationen übernommen werden. Jegliche Haftung für
            Schäden, die direkt oder indirekt aus der Benutzung dieser Webseite entstehen, wird ausgeschlossen, soweit
            diese nicht auf Vorsatz oder grober Fahrlässigkeit beruhen.
            <br />
            Wenn auf Internetseiten Dritter verwiesen wird, übernehmen wir für die Inhalte dieser verlinkten Seiten
            keine Verantwortung; bei diesen handelt es sich um fremde Inhalte, die sich {{ dealerName() }} vertreten
            durch {{ dealer().managingDirector }} ausdrücklich nicht zu eigen macht und auf die
            {{ dealerName() }} vertreten durch
            {{ dealer().managingDirector }}
            keinen Einfluss hat. Die Verantwortung für diese Inhalte liegt beim jeweiligen Anbieter.
            <br />
            Wir übernehmen keine Haftung für Schäden, die aus der Nutzung der Websites Dritter entstehen. Der Benutzer
            besucht diese Website auf eigene Gefahr. {{ dealerName() }} vertreten durch
            {{ dealer().managingDirector }} haftet nicht für Schäden, insbesondere materieller Art, den Verlust von
            Daten bzw. Programmen oder finanzielle Schäden, die sich aus dem Zugang oder der Benutzung dieser Website
            oder der mit ihr verbundenen Websites ergeben. Hiervon unberührt bleibt eine Haftung für Personenschäden
            sowie Vorsatz und grobe Fahrlässigkeit der {{ dealerName() }} vertreten durch
            {{ dealer().managingDirector }}, ihren Vertretern und Erfüllungsgehilfen.
            <br />
            <br />
            <strong>Jugendschutz</strong>
            <br />
            Die Nutzung und der Besuch der Website ist Kindern und Jugendlichen unter 18 Jahren ohne Zustimmung Ihrer
            Eltern nicht gestattet.
            <br />
            <br />
            <strong>Bekanntmachung von Änderungen</strong>
            <br />
            Wir sind jederzeit berechtigt, die Website unter Beachtung der aktuellen Vorgaben zu ändern.
            <br />
            Wir danken für Ihre Aufmerksamkeit und stehen Ihnen für Fragen zur Verfügung.
        </p>
    </div>
</div>
